import React from 'react';
import Base from './Base';
class DocumentControl extends Base {
    constructor(props) {
        super(props);
        this.finalizeAllDocuments = this.finalizeAllDocuments.bind(this);
        this.revertToDraft = this.revertToDraft.bind(this);
    }

    async finalizeAllDocuments() {
        try {
            const response = await fetch('/api/v1/document/finalizeAllDocuments', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({}),
            });

            const data = await response.json();
            this.showSuccessMessage(data.message);
        } catch (err) {
            this.showErorrMessage('خطایی در زمان ارسال درخواست نهایی کردن اسناد رخ داده است');
        }
    }

    async revertToDraft() {
        try {
            const response = await fetch('/api/v1/document/revertToDraft', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({}),
            });

            const data = await response.json();
            this.showSuccessMessage(data.message);
        } catch (err) {
            this.showErrorMessage('خطایی در زمان ارسال درخواست بازگرداندن اسناد به موقت رخ داده است');
        }
    }

    render() {
        return (
            <div className="nk-content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <div className="card-title-group pb-1 g-2 chart-title-bg">
                            <div className="card-title me-1">
                                <h6 className="title">تبدیل وضعیت اسناد به حالت دائمی</h6>
                                <p>قبل از صدور سند اختتامیه هر سال لازم است تمام اسناد مربوط به آن سال مالی را به حالت نهایی (دائمی) در آورید.</p>
                                </div>
                            </div>
                            <div className="nk-block mt-4">
                                <button className="btn btn-primary m-3" onClick={this.finalizeAllDocuments}>نهایی کردن تمامی اسناد دوره جاری</button>
                                <button className="btn btn-secondary m-3" onClick={this.revertToDraft}>بازگرداندن اسناد به حالت موقت</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DocumentControl;
